import { isLoggedIn } from "utils/auth";

export default (store) => {
  return {
    path: "personify/loyalty-signUp",
    onEnter: isLoggedIn(store),
    getComponent(nextState, cb) {
      require.ensure(
        [],
        (require) => {
          const PwaLoyaltySignUp = require("./PwaLoyaltySignUp").default;
          cb(null, PwaLoyaltySignUp);
        },
        "PwaLoyaltySignUp"
      );
    },
  };
};



// WEBPACK FOOTER //
// ./src/routes/PwaLoyaltySignUp/index.js